import { Controller } from "stimulus"
import createChannel from "cables/cable"

export default class extends Controller {

  initUserMessageChannel() {
    this.userMessageChannel = createChannel(
      {
        channel: 'UserMessageChannel'
      }, {
        received: data => {
          const partner = data.conversation_users.find(user => user.uid !== this.userUid);
          const targetConversation = this.element.querySelector(`[data-partner-uid="${partner.uid}"]`);
          if(targetConversation) {
            this.updateConversation(
              targetConversation, data.type, data.unread_messages_count, data.content, data.created_at
            );
          } else if(data.type === "send_message") {
            this.addConversation(
              data.conversation_id, data.unread_messages_count, data.content, data.created_at,
              partner.uid, partner.name, partner.image_url
            );
          }
        }
      }
    )
  }

  updateConversation(element, type, unreadMessagesCount, content, createdAt) {
    const unreadElement = element.querySelector(".unread-messages-count");
    unreadElement.textContent = unreadMessagesCount;
    unreadElement.style.display = unreadMessagesCount === 0 ? "none" : "";

    if(type === "read_message") { return; }

    const [_, createdAtDate, createdAtTime] = createdAt.match(/(\d{4}-\d{2}-\d{2})T(\d{2}:\d{2})/)
    const createdAtDateSlash = createdAtDate.replace(/-/g, "/");

    const contentElement = element.querySelector(".message-content");
    contentElement.textContent = content.length <= 50 ? content : (content.substr(0, 50)+"...");

    const createdAtElement = element.querySelector(".message-created-at");
    createdAtElement.textContent = createdAtDateSlash;

    // 先頭へ移動
    this.element.insertBefore(element, this.element.firstChild);
  }

  addConversation(conversationId, unreadMessagesCount, content, createdAt, partnerUid, partnerName, partnerImageUrl) {
    const [_, createdAtDate, createdAtTime] = createdAt.match(/(\d{4}-\d{2}-\d{2})T(\d{2}:\d{2})/)
    const createdAtDateSlash = createdAtDate.replace(/-/g, "/");

    const html = this.generateConversationHtmlString(conversationId, unreadMessagesCount, content, createdAtDateSlash, partnerUid, partnerName, partnerImageUrl);
    this.element.insertAdjacentHTML("afterbegin", html);
  }

  generateConversationHtmlString(conversationId, unreadMessagesCount, content, createdAtDateSlash, partnerUid, partnerName, partnerImageUrl) {
    return `
      <li class="p-4" data-partner-uid="${partnerUid}">
        <div style="position: relative; ">
          <a href="/conversations/${conversationId}" data-turbolinks="false" style="position: absolute; width: 100%; height: 100%;"></a>
          <article class="media">
            <figure class="media-left">
              <p class="image is-64x64">
                <img class=" is-rounded has-background-white" src="${partnerImageUrl}">
              </p>
            </figure>
            <div class="media-content">
              <p class="message-created-at is-pulled-right has-text-grey is-size-8">${createdAtDateSlash}</p>
              <h3 class="title is-5 mb-1">${partnerName}</h3>
              <p class="unread-messages-count is-pulled-right has-text-centered" style="${unreadMessagesCount === 0 ? "display: none;" : ""}">
                <span class="is-size-7"> ${unreadMessagesCount}</span>
              </p>
              <p class="message-content has-text-grey mr-5 is-size-7">${content}</p>
            </div>
          </article>
        </div>
      </li>
    `
  }

  connect() {
    this.userUid = this.element.dataset.userUid;
    this.initUserMessageChannel();
  }

  disconnect() {
    this.userMessageChannel.unsubscribe();
  }
}
